// assets
import { SearchOutlined } from "@ant-design/icons";
// import { Input } from 'antd';

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

const Search = () => (
  <div className="w-full ml-0 md:ml-2">
    {/* <Input
      size="small"
      id="header-search"
      prefix={<SearchOutlined />}
      placeholder="Search"
      className="w-full md:w-56"
      aria-label="search"
    /> */}
  </div>
);

export default Search;
